import resume from '@/views/resume/components/option'
import { resumeApi } from '@/api'

export default {
  namespaced: true,
  state: {
    resume,
    resumeCon: [],
    currForm: {},
    submitForm: {},
    list: [],
    drafts: null
  },
  mutations: {
    CHANGE_RESUME_CON(state, payload) {
      const { type, tem, idx } = payload
      const formList = state.resume[type].con.find(item => item.template === tem).formList
      if (formList.length === 1 && ['Edu'].includes(tem)) {
        this.$message.error('不能再删了')
      } else {
        formList.splice(idx, 1)
      }
      console.log(formList)
    },
    SET_RESUME_LIST(state, payload) {
      state.list = payload
    },
    SET_DRAFT(state, payload) {
      state.resumeCon = []
      state.resumeCon = payload.type ? state.resume[payload.type].con : []
      state.drafts = payload.res
      const res = JSON.parse(JSON.stringify(payload.res))
      for (const key in res) {
        if (['uid', 'id'].includes(key)) delete res[key]
        state.resumeCon.map(item => {
          if (item.type && item.type === key) {
            if (key === 'annex') {
              item.formList = res[key] && res[key].length ? [{}] : []
              item.isAdd = !window.location.href.includes('upload') && !res[key].length
              item.files = res[key]
            } else {
              item.formList = res[key]
            }
            delete res[key]
            // 单独将简历放在form
          } else if (item.template.toLowerCase() === key) {
            item.form[key] = res[key]
          } else if (item.form && item.template.toLowerCase() !== 'resume') {
            item.form = res
          }
          return item
        })
      }
      if (state.resumeCon[1].formList && !state.resumeCon[1].formList.length) state.resumeCon[1].formList = [{}]
      // if (state.resumeCon[0].form && !state.resumeCon[0].form.age) state.resumeCon[0].form.age = ''
    },

    DELETE_FORM(state, payload) {
      state.resumeCon = state.resumeCon.map(item => {
        if (item.type === payload.type && item.formList)item.formList = payload.formList
        return item
      })
    },

    SET_FORM(state, payload) {
      const curr = payload.key ? payload.con : payload
      // console.log(666, curr)
      if (!curr.length) return
      curr.forEach(item => {
        if (item.form) {
          for (const key in item.form) {
            if (item.form[key]) state.currForm[key] = item.form[key]
          }
          // 多条可填项
        } else if (item.type && item.formList.length && Object.keys(item.formList[0]).length && item.type !== 'annex') {
          state.currForm[item.type] = item.formList
        } else if (item.files) {
          state.currForm[item.type] = item.files
        }
      })

      delete state.currForm.uid
      delete state.currForm.id

      // 编辑数据
      if (payload.key) {
        if (payload.idx || Number(payload.idx) === 0) {
          const final = state.currForm[payload.key]
          const curr = state.drafts[payload.key]
          curr[payload.idx] = final[0]
          state.currForm[payload.key] = curr
        } else {
          if (state.currForm[payload.key]) {
            // 新增数据
            if (JSON.stringify(state.drafts) === '{}' || !state.drafts) {
              state.currForm[payload.key] = state.currForm[payload.key]
              // 追加数据
            } else {
              state.currForm[payload.key] = [...state.drafts[payload.key], ...state.currForm[payload.key]]
            }
          }
        }
      }
      // console.log(999, state.currForm, state.resumeCon)
    },

    RESET_FORM(state, payload) {
      for (const key in payload) {
        state.submitForm[key] = payload[key]

        // 拆分数组
        if (state.submitForm[key] && Array.isArray(state.submitForm[key]) && state.submitForm[key].length) {
          state.submitForm[key].map(item => {
            if (key === 'annex') delete item.file
            // 时间格式：返回值是数组，拆分成start_time、end_time

            if (item.date && item.date.length) {
              item.start_time = item.date[0]
              item.end_time = item.date[1]
            }
            delete item.date
            return item
          })
        } else if (key === 'resume') {
          if (JSON.stringify(payload.resume) === '{}') {
            delete state.submitForm[key]
          } else {
            delete state.submitForm[key].file
            delete state.submitForm[key].value
          }
        }

        delete state.submitForm.uid
        delete state.submitForm.id
        // 删除空数据
        if (!state.submitForm[key]) delete state.submitForm[key]
        // 删除[{}]的数据
        if (Array.isArray(state.submitForm[key]) && state.submitForm[key].length && JSON.stringify(state.submitForm[key][0]) === '{}') delete state.submitForm[key]
      }
    },

    RESET_RESUME(state) {
      state.currForm = {}
    }
  },
  actions: {
    async GET_RESUMR_LIST({ commit }, payload) {
      const res = await resumeApi.getList()
      commit('SET_RESUME_LIST', res)
    },
    async GET_DRAFT({ commit }, payload) {
      try {
        const res = await resumeApi.getDraft()
        commit('SET_DRAFT', { res, type: payload.type || 'online' })
      } catch (error) {
        commit('SET_DRAFT', { res: {}, type: payload.type || 'online' })
      }
    }
  }
}
